import {modals} from '@mantine/modals';
import {Text} from '@mantine/core';
import {Button} from '@mantine/core';
import {FaTrash} from 'react-icons/fa';

import {useMeteringRecords} from '../hooks/useMeteringRecords.ts';
import {MeteringRecord} from '../types';

interface DeleteRecordButtonProps {
    selectedRecords: MeteringRecord[];
    setSelectedRecords: (records: MeteringRecord[]) => void;
}

export const DeleteRecordButton = ({selectedRecords, setSelectedRecords}: DeleteRecordButtonProps) => {

    const {deleteRecords} = useMeteringRecords();

    const count = selectedRecords.length;
    const disabled = count === 0;

    const handleDelete = () => {
        const itemText = count === 1 ? 'item' : 'items';

        modals.openConfirmModal({
            title: 'Delete Metering Records',
            children: (
                <Text size="sm">
                    Are you sure you want to delete {count} {itemText}? This action cannot be undone.
                </Text>
            ),
            labels: {confirm: 'Delete', cancel: 'Cancel'},
            confirmProps: {color: 'red'},
            onConfirm: () => {
                const ids = selectedRecords.map(record => record.id);
                deleteRecords(ids);
                setSelectedRecords([]);
            },
        });
    };

    const buttonText = count > 0 ? `Delete (${count})` : 'Delete';

    return (
        <Button
            variant="outline"
            color="red"
            leftSection={<FaTrash size={16}/>}
            disabled={disabled}
            onClick={handleDelete}
        >
            {buttonText}
        </Button>
    );
};
